import React from 'react';
import { ScreenPerfProvider } from 'app/utils/performance/screen-perf-context';

export function withOptionalMetrics<P extends object>(
  screenName: string,
  Component: React.ComponentType<P>,
  enabled = true,
): React.FC<P> {
  function WithOptionalMetrics(props: P) {
    if (enabled) {
      return (
        <ScreenPerfProvider screenName={screenName}>
          <Component {...props} />
        </ScreenPerfProvider>
      );
    }

    return <Component {...props} />;
  }

  return WithOptionalMetrics;
}
